<template>
    <div class="common-box">
     <el-row class="row-one">
            <span class="row-one-title">组合收益明细</span>
            <Reback class="row-one-fr" @click.native="$router.go(-1)"></Reback>
    </el-row>
    <div class="instruction-li-title  margin-t30 aColor" style="font-size: 16px;">累计收益走势</div>
    <!-- 图表 -->
    <div class="margin-t20">
      <div id="combinationIncome" style="width:1148px;height:320px"> </div>
    </div>
    <div class="instruction-li-title  margin-t30 aColor" style="font-size: 16px;">日收益明细</div>
    <!-- 每日收益表格 -->
    <el-table class="table-one margin-t20" :data="tableData" border>
      <el-table-column prop="transactiondate1" label="日期">
      </el-table-column>
      <el-table-column prop="amount1" label="每日收益 ( 元 )">
        <template slot-scope="scope">
          <span v-if="scope.row.amount1 > 0" class="rColor">{{'+'+scope.row.amount1}}</span>
          <span v-else-if="scope.row.amount1 < 0" class="gColor">{{scope.row.amount1}}</span>
          <span v-else>{{scope.row.amount1}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transactiondate2" label="日期">
      </el-table-column>
      <el-table-column prop="amount2" label="每日收益 ( 元 )">
        <template slot-scope="scope">
          <span v-if="scope.row.amount2 > 0" class="rColor">{{'+'+scope.row.amount2}}</span>
          <span v-else-if="scope.row.amount2 < 0" class="gColor">{{scope.row.amount2}}</span>
          <span v-else>{{scope.row.amount2}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transactiondate3" label="日期">
      </el-table-column>
      <el-table-column prop="amount3" label="每日收益 ( 元 )">
        <template slot-scope="scope">
          <span v-if="scope.row.amount3 > 0" class="rColor">{{'+'+scope.row.amount3}}</span>
          <span v-else-if="scope.row.amount3 < 0" class="gColor">{{scope.row.amount3}}</span>
          <span v-else>{{scope.row.amount3}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transactiondate4" label="日期">
      </el-table-column>
      <el-table-column prop="amount4" label="每日收益 ( 元 )">
        <template slot-scope="scope">
          <span v-if="scope.row.amount4 > 0" class="rColor">{{'+'+scope.row.amount4}}</span>
          <span v-else-if="scope.row.amount4 < 0" class="gColor">{{scope.row.amount4}}</span>
          <span v-else>{{scope.row.amount4}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination class="pagination-single el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  data () {
    return {
      // 恒宝宝图表
      xdata: [],
      hbbserierData: [
        {
          name: '每日收益',
          data: [],
          type: 'line',
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#db9710'
            }, {
              offset: 1,
              color: '#fff'
            }])
          },
          symbol: 'none',
          itemStyle: {
            color: '#db9710',
          }
        }
      ],
      tableData: [],
      pageNum: 1,
      pageSize: 28,
      total: 0,
      combinationMessage: '',

    }
  },
  created () {
    this.combinationMessage = this.$route.params.message
    this.getSelectprofitGroupPage()
    this.getSelectprofitGroupTotal()
  },
  mounted () {
    this.$commonEcharts.echartsTwo('combinationIncome', this.xdata, false, this.hbbserierData, 2.35, '%', { 'yScale1': true })
  },
  methods: {
    handleSizeChange (newSize) {
      this.pageSize = newSize
      this.getSelectprofitGroupPage()
    },
    handleCurrentChange (newPage) {
      this.pageNum = newPage
      this.getSelectprofitGroupPage()
    },
    // 收益走势图
    getSelectprofitGroupTotal () {
      this.$http.post(this.$apiPath.selectprofitGroup, {
        combinationcode: this.combinationMessage.combinationcode,
        transactionaccountid: this.combinationMessage.transactionaccountid,
      }).then(res => {
        console.log(res);
        if (res.data.code == "200") {
          this.hbbserierData.data = []
          res.data.data.reverse().forEach(item => {
            this.xdata.push(this.$commonJs.getDateStrHg(item.date))
            this.hbbserierData.data.push(parseFloat(item.yestdayprofit).toFixed(2))
          })
          this.hbbserierData = [{ data: this.hbbserierData.data, }]
          this.$commonEcharts.echartsTwo('combinationIncome', this.xdata, false, this.hbbserierData, '元', { 'yScale1': true }, '每日收益（元）')
        }
      }).catch(err => { })
    },
    // 收益表格
    getSelectprofitGroupPage () {
      this.$http.post(this.$apiPath.selectprofitGroupPage, {
        combinationcode: this.combinationMessage.combinationcode,
        transactionaccountid: this.combinationMessage.transactionaccountid,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          const arr = []
          for (var i = 0; i < res.data.data.list.length; i += 4) {
            arr.push(res.data.data.list.slice(i, i + 4));
          }
          arr.forEach((item, i) => {
            if (item[0]) {
              item.transactiondate1 = item[0].date
              item.amount1 = parseFloat(item[0].yestdayprofit).toFixed(2)
            }
            if (item[1]) {
              item.transactiondate2 = item[1].date
              item.amount2 = parseFloat(item[1].yestdayprofit).toFixed(2)
            }
            if (item[2]) {
              item.transactiondate3 = item[2].date
              item.amount3 = parseFloat(item[2].yestdayprofit).toFixed(2)
            }
            if (item[3]) {
              item.transactiondate4 = item[3].date
              item.amount4 = parseFloat(item[3].yestdayprofit).toFixed(2)
            }

          })
          this.tableData = arr
          this.total = res.data.data.totalNum
        }
      }).catch(err => { })
    },
  }
}
</script>
<style lang="less" scoped>
</style>

